export const isMassview = window?.location?.href?.includes('massview.com');
export const isProduction = ['production'].includes(process.env.REACT_APP_ENV);
export const version = process.env.REACT_APP_VERSION || process.env.NODE_ENV;
export const appName = isMassview ? 'Massview' : 'Snagshout Partners';

// Five minutes in miliseconds
export const expirationTime = 300000;
